var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('object',{staticClass:"background",attrs:{"type":"image/svg+xml","data":_vm.backgroundSvg,"id":"svgobject","alt":"background"}}),_c('img',{staticClass:"pawn",attrs:{"src":require("@/assets/dineke.png")}}),_c('router-view',{on:{"addTiles":_vm.addTiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }